import Axios from 'axios'
import requestPrefix from '../requestPrefix'
import { localDev } from '../../utils/constant'

const prefix = localDev ? '' : requestPrefix.projectUrl

/**
 * 分页查询工地列表
 */
export function page(data) {
  return Axios({
    url: prefix + '/project/page',
    method: 'post',
    data: data
  })
}

export function listIdAndNameByUserId(data) {
  return Axios({
    url: prefix + '/project/selectProjectInfoByUserId',
    method: 'get',
    params: data
  })
}

export function saveDefaultProjectId(id) {
  return Axios({
    url: prefix + '/project/saveDefaultProjectId/' + id,
    method: 'get'
  })
}

/**
 *  查询无锡天气
 *  data extensions all预报 base实时
 */
export function weatherInfo(data) {
  return Axios({
    // url: prefix + '/kanban/all/weatherInfo',
    // method: 'get',
    // params: data
    url: '/project/project/getWuXiAirQuality',
    method: 'get'
  })
}

  // /**
  //  *  现用-天气接口
  //  */
  // getWuXiAirQuality() {
  //   return request({
  //     url: '/project/kanban/all/getWuXiAirQuality',
  //     method: 'get'
  //   })
  // },


// WEBPACK FOOTER //
// ./src/api/project/index.js